module.exports = __webpack_public_path__ + "static/media/colorbook-app_2screen.a54bb06d.png";